import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const EnergyNeeds = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/energy-needs/components/EnergyNeedsContent'
      )
  ),
  RightSidebar: lazy(
    () =>
      import(
        'components/direct-sales/energy-needs/components/EnergyNeedsSidebarRight'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/energy-needs/components/EnergyNeedsHeader'
      )
  ),
  Footer: lazy(
    () =>
      import(
        'components/direct-sales/energy-needs/components/EnergyNeedsFooter'
      )
  )
};

export default EnergyNeeds;
